import { gql } from '@apollo/client';

export default gql`
  mutation editUser(
    $name: String
    $surname: String
    $pushNotifications: Boolean
    $emailNotifications: Boolean
    $darkMode: Boolean
    $locale: String
  ) {
    editUser(
      input: {
        name: $name
        surname: $surname
        pushNotifications: $pushNotifications
        emailNotifications: $emailNotifications
        darkMode: $darkMode
        locale: $locale
      }
    ) {
      user {
        id
        email
        darkMode
        locale
      }
    }
  }
`;
